module.exports = __webpack_public_path__ + "statics/img/success-green.72c33f31.svg";